import { Flex } from 'foundations-components/components/Flex';
import { useSelector } from 'react-redux';
import { SegmentedTabNavItems } from '../../../constants/routing/NavItems';
import { usePageParams } from '../../../hooks/usePageParams';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { useSSM0009Experiment } from '../../../utils/experiments/ssm0009';
import SegmentedTabs from './SegmentedTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SegmentedTabsLayout = ({
  isIntersecting = false,
  selectedNavItem
}) => {
  const {
    isSSM0009Variant,
    isSSM0009Loading
  } = useSSM0009Experiment();
  const isAppAuth = useSelector(isAppAuthSelector);
  const hideTabs = isSSM0009Loading || isSSM0009Variant || isAppAuth || !SegmentedTabNavItems.includes(selectedNavItem);
  const {
    tab
  } = usePageParams();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !hideTabs && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(SegmentedTabs, {
        bordered: !hideTabs && isIntersecting,
        selectedTab: tab,
        path: `/${selectedNavItem}`
      })
    })
  });
};
export default SegmentedTabsLayout;